import { FC } from 'react';
import styled from 'styled-components';

import { Colors, DurationAndEasing, MediaMediumAndAbove, Spacing } from '@lichtblick/theme';

import { useSliderState } from './BasicSlider';

const LeftFade = styled.div<{ $color: Colors; $isVisible: boolean; $slideCount: number }>`
  background: linear-gradient(90deg, ${({ $color }) => `${$color}FF, ${$color}00`});
  display: none;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  transition: width ${DurationAndEasing.SmallIntro};
  width: ${({ $isVisible }) => ($isVisible ? Spacing.M : 0)};
  z-index: 1;
  ${MediaMediumAndAbove} {
    display: ${({ $slideCount }) => ($slideCount > 2 ? 'block' : 'none')};
  }
`;
const RightFade = styled.div<{ $color: Colors; $isVisible: boolean; $slideCount: number }>`
  background: linear-gradient(90deg, ${({ $color }) => `${$color}00 0%, ${$color}FF 100%`});
  display: none;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  transition: width ${DurationAndEasing.SmallIntro};
  width: ${({ $isVisible }) => ($isVisible ? Spacing.M : 0)};
  z-index: 1;
  ${MediaMediumAndAbove} {
    display: ${({ $slideCount }) => ($slideCount > 2 ? 'block' : 'none')};
  }
`;

export const Fade: FC<{ color: Colors; slideCount: number }> = ({ color, slideCount }) => {
  const { isBeginning, isEnd } = useSliderState();

  return (
    <>
      {<LeftFade $color={color} $isVisible={!isBeginning} $slideCount={slideCount} />}
      {<RightFade $color={color} $isVisible={!isEnd} $slideCount={slideCount} />}
    </>
  );
};
